import * as React from 'react';
const isPlainObject = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const setIn = (obj, path, value) => {
    if (path.length === 0) {
        return value;
    }
    const [head, ...rest] = path;
    const clone = (Array.isArray(obj) ? obj.slice() : Object.assign({}, obj));
    if (rest.length === 0) {
        clone[head] = value;
        return clone;
    }
    const next = obj === null || obj === void 0 ? void 0 : obj[head];
    clone[head] = setIn(next !== null && next !== void 0 ? next : (typeof rest[0] === 'number' ? [] : {}), rest, value);
    return clone;
};
export const useStateWithMutators = (initial) => {
    const [state, setState] = React.useState(initial);
    const build = (shape, path) => {
        if (Array.isArray(shape)) {
            return (value) => setState(prev => setIn(prev, path, value));
        }
        if (!isPlainObject(shape)) {
            return (value) => setState(prev => setIn(prev, path, value));
        }
        const out = {};
        out._ = (value) => setState(prev => setIn(prev, path, value));
        for (const key of Object.keys(shape)) {
            out[key] = build(shape[key], [...path, key]);
        }
        return out;
    };
    const mutators = React.useMemo(() => build(initial, []), []);
    return [state, mutators];
};
export default useStateWithMutators;
